<template>
  <div class="text-xs-center">
    <v-layout row justify-center>
      <v-dialog :value="dialog" persistent width="100">
        <v-card id="tranparency">
          <!--<v-card-title class="headline">Use Google's location service?</v-card-title>-->
          <!-- <v-card-text class="center" style="overflow-y: hidden !important;"> -->
            <!-- <v-progress-circular :size="120" :width="7" color="primary" indeterminate> -->
              <div class="center">
                <img class="loader" :src="`${basePath}images/loader.gif`" width="100px" />
                <!-- <br> -->
                <!-- <span>Carregando</span> -->
              </div>
            <!-- </v-progress-circular> -->
            <!--<v-progress-linear-->
            <!--indeterminate-->
            <!--color="white"-->
            <!--class="mb-0"-->
            <!--&gt;</v-progress-linear>-->
          <!-- </v-card-text> -->
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'loader',
  data: () => ({
    basePath: process.env.API
  }),
  computed: {
    dialog () {
      return this.$store.getters[`loader/dialog`] || false
    }
  }
}
</script>

<style scoped>
.center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

#tranparency {
  background-color: rgba(255, 255, 255, 0.7) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/PLoader.vue